import loadable from "@loadable/component";
export default loadable(function() {
    return import("./powerbi-report");
});
